<template>
  <router-link  tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div
      class="nav-dropdown-toggle"
      style="cursor: pointer;"
      @click="handleClick"
    >
      <a href="javascript:;" style="pointer-events: none;" class="nav-link">
        <font-awesome-icon :icon="classIcon" /> {{ name }}
      </a>
    </div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
  computed: {
    classIcon() {
      return ['fas', this.icon]
    },
  },
  methods: {
    handleClick(e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
  },
}
</script>

<style scoped lang="css">
.nav-link {
  cursor:pointer;
}
</style>
